import { lazy, Suspense } from "react";
import { useAuth } from "@/context/AuthContext";

// v75 — the panel's code is a separate chunk, loaded only for the super admin.
const Panel = lazy(() => import("@/components/admin/ReserveCheckPanel"));

export function ReserveCheckSlot({ id }) {
  const { user } = useAuth();
  if (!user?.is_super_admin || !id) return null;
  return <Suspense fallback={null}><Panel id={id} /></Suspense>;
}
